export default "__VITE_ASSET__BCm5QSv5__"